<template>
  <v-layout
    v-if="activeBill"
    row
    align-center
    :style="myLayoutStyle"
  >
    <v-flex
      xs12
      sm10
      offset-sm1
      md10
      offset-md1
      lg10
      offset-lg1
      xl8
      offset-xl2
    >
      <v-card
        flat
        :color="theme.bg_color"
      >
        <v-card-text>
          <h2 :style="titleStyle">
            {{ title }}
          </h2>
          <div v-if="activeBill && activeBill.billno">
            <v-divider class="mt-1 mb-1" :color="theme.orders_divider_color" />
            <v-layout
              row
              align-center
            >
              <v-flex 
                xs3
                sm3
                md3
                lg2
                xl2
                :style="nameStyle"
              >{{ $t('table') }}: </v-flex>
              <v-flex
                xs9
                sm9
                md9
                lg10
                xl10
                :style="nameStyle"
              >{{ tableName }}</v-flex>
            </v-layout>
            <v-layout
              row
              align-center
            >
              <v-flex
                xs3
                sm3
                md3
                lg2
                xl2
                :style="nameStyle"
              >{{ $t('open_date') }}: </v-flex>
              <v-flex
                xs9
                sm9
                md9
                lg10
                xl10
                :style="nameStyle"
              >{{ activeBill.opendate }}</v-flex>
            </v-layout>
            <v-divider class="mt-2 mb-2" :color="theme.orders_divider_color" />
            <div
              v-for="(o, index) in activeBill.order"
              :key="index"
            >
              <bill-order :item="o" />
              <v-divider
                v-if="index === activeBill.order.length - 1"
                class="mt-2 mb-2"
                :color="theme.orders_divider_color"
              />
            </div>
            <v-layout
              row
              align-center
              mb-1
            >
              <v-flex 
                xs9
                sm9
                md9
                lg10
                xl10
                class="text-xs-right"
                :style="nameStyle"
              >
                Subtotal: 
              </v-flex>
              <v-flex 
                xs3
                sm3
                md3
                lg2
                xl2
                class="text-xs-right"
                :style="nameStyle"
              >
                {{ $n(parseFloat(activeBill.subtotal), 'currency') }}
              </v-flex>
            </v-layout>
            <v-layout
              v-if="svc"
              row
              align-center
              mb-1
            >
              <v-flex 
                xs9
                sm9
                md9
                lg10
                xl10
                class="text-xs-right"
                :style="nameStyle"
              >
                {{ svc.name }}
              </v-flex>
              <v-flex 
                xs3
                sm3
                md3
                lg2
                xl2
                class="text-xs-right"
                :style="nameStyle"
              >
                {{ $n(parseFloat(svc.price), 'currency') }}
              </v-flex>
            </v-layout>
            <v-layout
              v-if="gst"
              row
              align-center
              mb-1
            >
              <v-flex 
                xs9
                sm9
                md9
                lg10
                xl10
                class="text-xs-right"
                :style="nameStyle"
              >
                {{ gst.name }}
              </v-flex>
              <v-flex 
                xs3
                sm3
                md3
                lg2
                xl2
                class="text-xs-right"
                :style="nameStyle"
              >
                {{ $n(parseFloat(gst.price), 'currency') }}
              </v-flex>
            </v-layout>
            <v-layout
              v-if="rounding !== 0"
              row
              align-center
              mb-1
            >
              <v-flex 
                xs9
                sm9
                md9
                lg10
                xl10
                class="text-xs-right"
                :style="nameStyle"
              >
                Rounding:
              </v-flex>
              <v-flex 
                xs3
                sm3
                md3
                lg2
                xl2
                class="text-xs-right"
                :style="nameStyle"
              >
                {{ $n(parseFloat(rounding), 'currency') }}
              </v-flex>
            </v-layout>
            <v-layout
              row
              align-center
              mb-1
            >
              <v-flex 
                xs9
                sm9
                md9
                lg10
                xl10
                class="text-xs-right"
                :style="nameStyle"
              >
                Total: 
              </v-flex>
              <v-flex 
                xs3
                sm3
                md3
                lg2
                xl2
                class="text-xs-right"
                :style="nameStyle"
              >
                {{ $n(total, 'currency') }}
              </v-flex>
            </v-layout>
            <div>
              <v-divider class="mt-2 mb-2" :color="theme.orders_divider_color" />
              <h3
                class="mb-2 mt-3"
                :style="mySubtitleStyle"
              >{{ $t('select_payment_mode') }}</h3>
              <v-layout
                row
                align-center
                v-for="p in paymentModes"
                :key="p.code"
              >
                <v-flex 
                  xs12
                  sm8
                  md6
                  lg4
                  xl3
                >
                  <v-btn
                    flat
                    :color="theme.orders_name_color"
                    :style="paymentModeBtnStyle(p.code)"
                    @click="setPaymentMode(p)"
                  >
                    <v-icon>{{ paymentTypes[p.code].icon }}</v-icon>
                    <span class="payment-option">{{ $t(paymentTypes[p.code].title) }}</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import PageTitle from '~/components/PageTitle'
import BillOrder from '~/components/BillOrder'

export default {
  name: 'bill-view',
  metaInfo () {
    return { title: 'Bill detail' }
  },
  components: {
    'page-title': PageTitle,
    'bill-order': BillOrder,
  },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'iOS', 'inIframe', 'paymentModes', 'paymentTypes'
    ]),
    ...mapGetters('order', [
      'openTables', 'activeBill', 'paymentMode'
    ]),
    myLayoutStyle () {
      return {
        marginLeft: '-8px',
        marginRight: '-8px',
        marginBottom: '-16px',
        backgroundColor: this.theme.bg_color
      }
    },
    mySubtitleStyle () {
      return {
        color: this.theme.orders_title_color
      }
    },
    titleStyle () {
      return {
        display: 'inline-block',
        lineHeight: '40px',
        color: this.theme.orders_title_color
      }
    },
    nameStyle () {
      return {
        color: this.theme.orders_name_color
      }
    },
    openTable () {
      const o = this.openTables.find(i => parseInt(i.table_id) === parseInt(this.id))
      return o ? o : null
    },
    title () {
      if (this.activeBill && this.activeBill.billno) {
        return this.$t('bill') +': ' + this.activeBill.billno
      }
      return '* ' + this.$t('bill_not_found_title')
    },
    tableName () {
      if (this.openTable.m_table) {
        return this.openTable.m_table.Name
      }
      return '-'
    },
    svc () {
      if (this.activeBill.svc) {
        return {
          name: this.activeBill.svcname + ':' || 'SVC:',
          price: this.activeBill.svc || 0
        }
      }
      return null
    },
    gst () {
      if (this.activeBill.gst) {
        return {
          name: this.activeBill.gstname + ':' || 'GST:',
          price: this.activeBill.gst || 0
        }
      }
      return null
    },
    rounding () {
      return -(this.activeBill.rounding) || 0
    },
    total () {
      return parseFloat(this.activeBill.total) || 0
    }
  },
  methods: {
    paymentModeBtnStyle (code) {
      if (this.paymentMode && this.paymentMode.code === code) {
        return {
          backgroundColor: this.theme.address_bg_color,
          borderRadius: '3px',
          color: this.theme.address_text_color
        }
      }
    },
    setPaymentMode (mode) {
      this.$store.dispatch('order/setPaymentMode', { ...mode, payType: 'payment' })
    },
  },
  beforeMount () {
    if (!this.activeBill) {
      this.$router.push({ name: 'bills' })
    }
  },
  created () {
    // Set default if only have one payment mode
    if (this.paymentModes.length === 1) {
      this.$store.dispatch('order/setPaymentMode', { ...this.paymentModes[0], payType: 'payment' })
    }
  }
}
</script>

<style scoped>
.payment-option {
  padding-left: 10px;
  text-transform: capitalize;
}
</style>


// WEBPACK FOOTER //
// src/pages/bill.vue